import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/auth'


const firebaseConfig = {
    apiKey: "AIzaSyD7g6UFn5eky6BgiM5zv7vR9_MS5CUYqAY",
    authDomain: "ecommerce-815eb.firebaseapp.com",
    projectId: "ecommerce-815eb",
    storageBucket: "ecommerce-815eb.appspot.com",
    messagingSenderId: "1089487392674",
    appId: "1:1089487392674:web:877ebc34d44810840c6cfb",
    measurementId: "G-17ELZYMVT0"
  };

  export const Firebase = firebase.initializeApp(firebaseConfig)